export { default } from './InternalAdminsTab';
export { default as reducer } from './InternalAdminsTab.ducks';
export { default as sagas } from './InternalAdminsTab.sagas';

import * as actions from './InternalAdminsTab.ducks';

export { actions };
